<template>
  <div class="bg-light px-3">
    <SurplusReturnPartAdd
      v-if="returnDraftDto.ReturnDraftType === 'Surplus'"
      :return-draft-dto="returnDraftDto"
    />
    <ExpressReturnPartAdd
      v-else
      :return-draft-dto="returnDraftDto"
    />
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import ExpressReturnPartAdd from "./ExpressReturnPartAdd"
  import SurplusReturnPartAdd from "./SurplusReturnPartAdd"
  import { returnAddItems } from "./mixins/AddItems"
  import { stringHelper } from "@/components/mixins/stringHelper"
  export default {
    components: {
      ExpressReturnPartAdd,
      SurplusReturnPartAdd
    },
   
    mixins: [returnAddItems,stringHelper],

    props: {
      returnDraftDto: {
        type: Object,
        default: () => ({})
      },

      validationState: {
        type: Object,
        default: () => ({}),
        stepOne: {type: Boolean, default: false},
        stepTwo: {type: Boolean, default: false},
        stepThree: {type: Boolean, default: false},
        stepFour: {type: Boolean, default: false}
      }
    },
    data: () => ({
      intl: Object
    }),
    computed: {
      ...mapGetters([
        "hasPermission",
      ]),
    },
    watch: {
      "returnDraftDto.Items": function() {
        this.doValidation();
      }
    },
    methods: {
      doValidation(){
        let total = 0;
        this.validationState.stepTwo = true;

        if( this.hasPermission("IgnoreReturnValidation")){
          return;
        }

        if(this.returnDraftDto.Errors.length > 0) {
          this.validationState.stepTwo = false;
          for (let i = 0; i < this.returnDraftDto.Errors.length; i++){
            if(this.returnDraftDto.Errors[i] === "ExceedsMaAuthorizedAmount") {
              this.$store.commit("pushTimedMessage",{
                header: "Return Exceeds Maximum Return Amount",
                message: this.getContentItem("ReturnExceedMaximumAmount"),
                IsError: true,
                seconds: 120
              });
            }
          }
        }

        if(this.returnDraftDto.Items.length < 1 || this.returnDraftDto.Errors.length > 0){
          this.validationState.stepTwo = false;
          return;
        }

        for (let x = 0; x < this.returnDraftDto.Items.length; x++)
        {
          total += this.returnDraftDto.Items[x].Total;
          if (this.returnDraftDto.Items[x].Errors.length > 0) {
            this.validationState.stepTwo = false 
            return // if any item has an error we are invalid
          }
        }

        if(total < this.returnDraftDto.MinimumReturnAmount){
          let amount = this.returnDraftDto.MinimumReturnAmount;
          let currencyAmount = this.formatToCurrency(amount, this.returnDraftDto.Items[0].Currency);

          this.$store.commit("pushTimedMessage",{
            header: "Error in return items",
            message: this.format(this.getContentItem("ReturnTotalMinimumAmount"), currencyAmount),
            IsError: true,
            seconds: 20
          });
          this.validationState.stepTwo = false
          return
        }
       
      }
    }
  }
</script>
